import { render, staticRenderFns } from "./iconsPage.vue?vue&type=template&id=1b30eb6d&"
import script from "./iconsPage.vue?vue&type=script&lang=js&"
export * from "./iconsPage.vue?vue&type=script&lang=js&"
import style0 from "./iconsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports